var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcGears = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "86px",
    height: "83px",
    viewBox: "0 0 86 83",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "F1BC0813-727B-4AC3-A150-27C5448F8EF5")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "obox",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "serwis",
    transform: "translate(-917.000000, -610.000000)",
    stroke: "#4197CA",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic",
    transform: "translate(917.000000, 610.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Android-TV",
    transform: "translate(0.868000, 24.345000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_00-copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_serwis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.614,0 L22.369,0 L22.369,3.626 C19.127491,3.99385897 16.0139564,5.10207201 13.269,6.865 L10.986,4.143 L6.968,7.515 L9.234,10.215 C6.98102655,12.6010808 5.30719201,15.4734931 4.342,18.61 L0.91,18.01 L-0.001,23.175 L3.425,23.775 L3.41,24.339 C3.40533333,24.5256667 3.403,24.713 3.403,24.901 C3.39916889,27.805447 3.98819002,30.6801151 5.134,33.349 L2.104,35.1 L4.727,39.642 L7.783,37.877 C9.7649893,40.475723 12.3131804,42.5885568 15.234,44.055 L14.007,47.428 L18.936,49.222 L20.177,45.81 C23.3419859,46.5058706 26.6229625,46.4809215 29.777,45.737 L31.046,49.222 L35.975,47.428 L34.693,43.905 C37.5448752,42.4181607 40.0270905,40.3108064 41.957,37.738 L45.257,39.638 L47.879,35.1 L44.569,33.189 C45.6703847,30.564495 46.2358045,27.7462361 46.232,24.9 C46.232,24.732 46.23,24.5653333 46.226,24.4 L46.213,23.837 L49.982,23.173 L49.071,18.008 L45.31,18.671 C44.3746205,15.5987308 42.7593219,12.7765723 40.584,10.414 L43.014,7.514 L38.997,4.143 L36.59,7.011 C33.8904891,5.22933966 30.8204062,4.08639469 27.613,3.669 L27.614,0 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    cx: 24.991,
    cy: 24.914,
    r: 12.457
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Android-TV-2",
    transform: "translate(47.114000, 0.750000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_00-copy-3-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_serwis-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.861,0 L16.899,0 L16.899,2.739 C14.4503999,3.0170183 12.0984929,3.85424791 10.025,5.186 L8.299,3.13 L5.264,5.677 L6.976,7.717 C5.27458128,9.51972372 4.01065767,11.6896759 3.282,14.059 L0.689,13.6 L0.001,17.5 L2.589,17.957 L2.578,18.383 C2.57466667,18.5243333 2.573,18.6656667 2.573,18.807 C2.56990747,21.0011018 3.01464975,23.1727507 3.88,25.189 L1.59,26.512 L3.571,29.944 L5.88,28.611 C7.37736711,30.574147 9.30244336,32.1702264 11.509,33.278 L10.582,35.826 L14.305,37.181 L15.243,34.603 C17.6348379,35.1291516 20.114414,35.110354 22.498,34.548 L23.456,37.181 L27.18,35.826 L26.212,33.165 C28.3662503,32.0416542 30.2412339,30.4496096 31.699,28.506 L34.19,29.944 L36.171,26.512 L33.671,25.068 C34.5028021,23.0855794 34.9298389,20.9568553 34.927,18.807 C34.927,18.6796667 34.927,18.553 34.927,18.427 L34.917,18.002 L37.764,17.502 L37.076,13.602 L34.235,14.102 C33.5284788,11.780988 32.3082882,9.6489014 30.665,7.864 L32.501,5.676 L29.46,3.13 L27.642,5.3 C25.6028831,3.95403146 23.2838268,3.09049846 20.861,2.775 L20.861,0 Z",
    id: "Combined-Shape-2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5-2",
    cx: 18.88,
    cy: 18.822,
    r: 9.411
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Android-TV-3",
    transform: "translate(53.937000, 51.544000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_00-copy-3-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_serwis-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.934,0 L13.717,0 L13.717,2.224 C11.7310906,2.45029224 9.82370683,3.12976565 8.142,4.21 L6.742,2.541 L4.273,4.608 L5.662,6.264 C4.28036538,7.72717156 3.25388957,9.48860405 2.662,11.412 L0.562,11.041 L0.003,14.209 L2.103,14.58 L2.094,14.926 C2.094,15.0406667 2.094,15.1556667 2.094,15.271 C2.0915648,17.0518688 2.45259803,18.8145004 3.155,20.451 L1.29,21.524 L2.898,24.309 L4.772,23.227 C5.98771694,24.8205109 7.55062811,26.115983 9.342,27.015 L8.589,29.084 L11.611,30.184 L12.372,28.092 C14.3135212,28.5189566 16.3262302,28.5035768 18.261,28.047 L19.039,30.184 L22.061,29.084 L21.275,26.924 C23.023703,26.0121147 24.5456993,24.7197505 25.729,23.142 L27.751,24.309 L29.359,21.523 L27.33,20.351 C28.0053472,18.7419238 28.3521451,17.0140546 28.35,15.269 C28.35,15.1656667 28.35,15.0626667 28.35,14.96 L28.342,14.615 L30.653,14.208 L30.094,11.041 L27.788,11.448 C27.2139401,9.56361636 26.2227353,7.83276779 24.888,6.384 L26.378,4.608 L23.914,2.541 L22.442,4.3 C20.788105,3.20791648 18.9072076,2.5068547 16.942,2.25 L16.934,0 Z",
    id: "Combined-Shape-3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5-3",
    cx: 15.325,
    cy: 15.278,
    r: 7.639
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcGears, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_gears.d5b2f460.svg";
export { ForwardRef as ReactComponent };